<template>
    <div class="benefits">
        <div class="container">
            <h2 class="cms-content-heading">Why buy from Stellantis &You UK?</h2>
        </div>

        <div class="container benefits__grid">
            <div class="benefits__item">
                <svg class="benefits__icon benefits__icon--warranty">
                    <use href="#svg-warranty-icon" />
                </svg>
                <h2 class="benefits__title">Minimum {{ formattedWarranty }} warranty</h2>
                <p>We offer {{ formattedWarranty }} warranty on this vehicle. This covers all mechanical and electrical components to ensure all the essentials are covered..</p>
            </div>

            <div class="benefits__item">
                <svg class="benefits__icon benefits__icon--vehicle-check">
                    <use href="#svg-vehicle-check-icon" />
                </svg>
                <h2 class="benefits__title">Full vehicle check</h2>
                <p>All our used vehicles receive a full comprehensive vehicle inspection plus a history of ownership check, so you can drive away with full peace of mind</p>
            </div>

            <div class="benefits__item">
                <svg class="benefits__icon benefits__icon--right-price">
                    <use href="#svg-right-price-icon" />
                </svg>
                <h2 class="benefits__title">Always the right price</h2>
                <p>We check and compare all our prices in the local market to ensure you always pay the right price for your
                    used vehicle. </p>
            </div>

            <div class="benefits__item">
                <svg class="benefits__icon benefits__icon--money-back">
                    <use href="#svg-money-back-icon" />
                </svg>
                <h2 class="benefits__title">14 day money back guarantee</h2>
                <p>You can return your vehicle within two weeks of purchase for any reason thanks to our 14 day money back
                    guarantee.</p>
            </div>
        </div>
    </div>
</template>

<script>
import FormatWarranty from '../../api/FormatWarranty';

export default {
    data() {
        return {};
    },
    props: {
        'vehicle': {
            type: Object,
            required: true
        },
    },
    computed: {
        formattedWarranty() {
            return FormatWarranty(this.vehicle.warranty_months).toLowerCase();
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/redesign/variables";

.cms-content-heading {
    color: $dark-blue;
    margin-bottom: 30px;
}

.benefits {
    margin-top: 30px;
    padding-top: 60px;
    padding-bottom: 60px;
    background-color: $light-blue;

    &__grid {
        display: grid;
        gap: 15px;
        margin-top: 10px;

        @media (min-width: $screen-md) {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }

    &__title {
        color: $dark-blue;
        font-size: 16px;
        line-height: 18px;
    }

    &__icon {
        fill: $blue;
        margin-bottom: 15px;

        &--warranty {
            width: 42.99px;
            height: 64px;
        }

        &--healthcheck {
            width: 46px;
            height: 64px;
        }

        &--vehicle-check {
            width: 95.24px;
            height: 64px;
        }

        &--right-price {
            width: 63px;
            height: 64px;
        }

        &--money-back {
            width: 57px;
            height: 64px;
        }

        &--technician {
            width: 52px;
            height: 64px;
            fill: none;
            stroke: $blue;
            stroke-width: 1.5px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/UsedDetails/Benefits.vue